<div class="frame" *ngIf="product" style="border: 1px solid #e6e6e6">
  <swiper [config]="representationScrollConfigs" *ngIf="product.representationPhotos?.length > 1">
    <ng-template swiperSlide *ngFor="let photo of product.representationPhotos; let i = index" style="cursor: pointer">
      <ai-image-edit-overlay
        [imageUrl]="photo.photo"
        [imageKey]="getRepresentationKey(i)"
        [showEditButton]="isAdminPage"
        (imageUpdated)="onRepresentationPhotoUpdated(i, $event)"
      >
        <img [src]="photo.photo" style="width: auto; max-width: 100%; height: auto; max-height: 100%" />
      </ai-image-edit-overlay>
    </ng-template>
  </swiper>
  <ai-image-edit-overlay
    *ngIf="product.representationPhotos?.length === 1"
    [imageUrl]="product.representationPhotos?.[0]?.photo"
    [imageKey]="getRepresentationKey(0)"
    [showEditButton]="isAdminPage"
    (imageUpdated)="onRepresentationPhotoUpdated(0, $event)"
  >
    <img [src]="product.representationPhotos?.[0]?.photo" />
  </ai-image-edit-overlay>
  <div *ngIf="product.representationPhotos?.length === 0" class="skeleton"></div>

  <!-- 실제 product-summary와 동일한 구조 -->
  <div class="section-md">
    <!-- 제목과 가격 정보 (saleTpl과 동일) -->
    <div style="margin-bottom: 12px">
      <!-- 카테고리, 지역, 업체명 -->
      <div
        style="
          display: flex;
          gap: 4px;
          align-items: center;
          font-size: 15px;
          font-weight: 500;
          margin-bottom: 2px;
          color: #5b6371;
        "
      >
        <div>{{ product.representationCategory || '카테고리' }}·{{ getRegion() }}</div>
        <div>{{ product.bizName || '' }}</div>
      </div>
      <!-- 제목 -->
      <div class="title">{{ product.title || '상품 제목을 입력해주세요' }}</div>
    </div>

    <!-- 가격 섹션 -->
    <div style="display: flex; gap: 12px; flex-direction: column">
      <div style="line-height: 100%">
        <!-- 할인가격이 있는 경우 -->
        <div *ngIf="product.discountPrice && product.discountPrice !== product.price">
          <div style="display: flex; align-items: center; gap: 4px; margin-bottom: 4px">
            <div style="color: #570dca; font-size: 18px; font-weight: 700; line-height: 100%">
              {{ getDiscountPercent() }}%
            </div>
            <div style="color: #a6a8b8; font-size: 14px; font-weight: 400; text-decoration-line: line-through">
              {{ formatPrice(product.price) }}원
            </div>
          </div>
          <div style="font-size: 20px; font-weight: 600; letter-spacing: -0.4px">
            <div *ngIf="product.discountPrice > 0" style="display: flex; gap: 4px; align-items: flex-end">
              <div>{{ formatPrice(product.discountPrice) }}원</div>
            </div>
            <div *ngIf="product.discountPrice == 0">무료</div>
          </div>
        </div>

        <!-- 할인가격이 없는 경우 -->
        <div *ngIf="!product.discountPrice || product.discountPrice === product.price">
          <div style="font-size: 20px; font-weight: 600; letter-spacing: -0.4px">
            <div *ngIf="product.price > 0" style="display: flex; gap: 4px; align-items: flex-end">
              <div>{{ formatPrice(product.price) }}원</div>
            </div>
            <div *ngIf="product.price == 0">무료</div>
          </div>
        </div>

      </div>

      <!-- 배지들 -->
      <div style="display: inline-flex; gap: 6px; flex-direction: column; align-items: flex-start">
        <div
          *ngIf="product.agency"
          class="nnb-badge nnb-badge-md nnb-badge-light-grey"
          style="height: 30px; display: inline-flex; gap: 3px; align-items: center"
        >
          <img *ngIf="product.agencyImage" style="width: 16px; height: 16px" [src]="product.agencyImage" />
          {{ product.agency }}
        </div>
      </div>

      <!-- 후기 및 찜 정보 -->
      <div style="display: flex; gap: 17.5px; align-items: center">
        <div style="display: flex; gap: 4px; align-items: center">
          <img src="/assets/new/message-filled.svg" style="width: 18px; height: 18px" />
          <div class="info">후기</div>
          <div class="like">9,999건</div>
        </div>
        <div style="display: flex; gap: 4px; align-items: center">
          <img src="/assets/new/heart-dark-grey.svg" style="width: 18px; height: 18px" />
          <div class="info">찜</div>
          <div class="info">9,999</div>
        </div>
      </div>
    </div>

    <!-- 해시태그 (실제와 동일한 위치와 스타일) -->
    <div
      style="
        gap: 8px;
        margin-top: 16px;
        margin-bottom: 40px;
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;
        display: flex;
        align-items: center;
      "
      *ngIf="product.hashtags?.length"
    >
      <ng-container *ngFor="let hashtag of product.hashtags">
        <div *ngIf="hashtag?.name" class="hashtag">#{{ hashtag.name }}&nbsp;</div>
      </ng-container>
    </div>

    <!-- 호스트 -->
    <div style="font-size: 16px; font-weight: 500; margin-bottom: 8px">호스트</div>
    <div
      style="
        margin-bottom: 8px;
        border-radius: 8px;
        border: 1px solid #e8e8ef;
        padding: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      "
    >
      <div style="display: flex; justify-content: space-between; align-items: center; gap: 4px">
        <img
          *ngIf="product.host?.profilePhoto"
          style="width: 40px; height: 40px; border-radius: 50%"
          [src]="product.host.profilePhoto"
        />
        <img
          *ngIf="!product.host?.profilePhoto"
          style="
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background: #f0f0f0;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #999;
          "
          src="/assets/new/user.svg"
        />
        <img *ngIf="product.host?.phoneNumber" src="/assets/new/host.svg" class="nnb-icon" />
        <div style="font-weight: 500">{{ product.host?.nickname || '호스트명을 입력해주세요' }}</div>
      </div>
      <img src="/assets/new/arrow-right.svg" style="width: 24px; height: 24px" />
    </div>
    <div style="font-size: 14px; color: #5b6371; line-height: 140%">
      해당 상품을 직접 운영하며 친절함과 체계적인 운영 검증이 완료된 호스트 입니다.
    </div>

    <!-- 상품 추가 정보 표시 -->
    <div
      *ngIf="product.bizName || product.representationCategory || product.runningDays"
      style="margin-top: 24px; padding: 16px; background: #f8f9fa; border-radius: 8px"
    >
      <div style="font-size: 16px; font-weight: 500; margin-bottom: 12px; color: #495057">상품 정보</div>
      <div *ngIf="product.bizName" style="display: flex; gap: 8px; margin-bottom: 8px">
        <span style="color: #6c757d; min-width: 60px">업체명:</span>
        <span>{{ product.bizName }}</span>
      </div>
      <div *ngIf="product.representationCategory" style="display: flex; gap: 8px; margin-bottom: 8px">
        <span style="color: #6c757d; min-width: 60px">카테고리:</span>
        <span>{{ product.representationCategory }}</span>
      </div>
      <div style="display: flex; gap: 8px; margin-bottom: 8px">
        <span style="color: #6c757d; min-width: 60px">소요시간:</span>
        <span>{{ formatDuration() }}</span>
      </div>
    </div>
  </div>

  <main>
    <ng-container *ngIf="product.version === 1">
      <!-- 상품 메뉴 -->
      <div class="menu">
        <div
          class="top-menu"
          [ngClass]="'section-introduction-' + product.id"
          (click)="setPosition('introduction', product.id)"
        >
          소개
        </div>

        <div
          *ngIf="product.courses?.length > 0"
          class="top-menu"
          [ngClass]="'section-schedule-' + product.id"
          (click)="setPosition('schedule', product.id)"
        >
          일정
        </div>

        <div
          *ngIf="product.isBusiness"
          class="top-menu"
          [ngClass]="'section-info-' + product.id"
          (click)="setPosition('info', product.id)"
        >
          정보
        </div>

        <div class="top-menu" [ngClass]="'section-place-' + product.id" (click)="setPosition('place', product.id)">
          장소
        </div>

        <div class="top-menu" [ngClass]="'section-feed-' + product.id" (click)="setPosition('feed', product.id)">
          후기
        </div>
      </div>
      <!-- 체크 포인트 & 추천 성향-->
      <div *ngIf="product.id !== 614 && product.id !== 848">
        <div *ngIf="product.point && product.recommend" class="section" [id]="'section-introduction-' + product.id">
          <ng-container *ngIf="product.point">
            <div class="info-box">
              <div class="label">체크 포인트</div>
              <div class="pre-wrap">{{ product.point }}</div>
            </div>
          </ng-container>
          <div *ngIf="product.point && product.recommend" style="margin-bottom: 24px"></div>
          <ng-container *ngIf="product.recommend">
            <div class="info-box">
              <div class="label">추천 성향</div>
              <div class="pre-wrap">{{ product.recommend }}</div>
            </div>
          </ng-container>
        </div>
        <div *ngIf="product.recommend" style="margin-bottom: 24px"></div>
      </div>
      <!-- 소개 -->
      <div>
        <div *ngIf="product.description" [id]="'section-introduction-' + product.id">
          <div class="section">
            <div class="section-title">소개</div>
            <div *ngIf="product.isBusiness" class="ql-container ql-snow" [style]="quillStyle">
              <div class="ql-editor" [innerHTML]="product.description | safeHtml"></div>
            </div>
            <p *ngIf="!product.isBusiness" class="pre-wrap">{{ product.description }}</p>
            <br />
            <!-- description 이미지 편집 (admin only) -->
            <description-image-editor
              *ngIf="product.isBusiness"
              [descriptionHtml]="product.description"
              [isAdminPage]="isAdminPage"
              (descriptionUpdated)="onDescriptionImageUpdated($event)"
            >
            </description-image-editor>
          </div>
        </div>
      </div>
      <!-- [섹션] 일정 -->
      <ng-container *ngIf="product.id !== 614">
        <div class="section" [id]="'section-schedule-' + product.id" *ngIf="product.courses?.length > 0">
          <div class="section-title">일정</div>
          <div class="course" *ngFor="let course of product.courses">
            <div class="title">{{ course.title }}</div>
            <ng-container *ngFor="let schedule of course.schedules">
              <div style="display: flex; gap: 9px; min-height: 48px; align-items: center">
                <div style="display: flex; align-items: center; gap: 8px">
                  <div class="subTitle">{{ schedule.subTitle }}</div>
                  <div style="border-left: 2.5px solid #e5e5e5; height: 23px"></div>
                </div>
                <div class="content2">{{ schedule.content }}</div>
              </div>
              <hr style="margin: 12px 0px" />
            </ng-container>
          </div>
        </div>
      </ng-container>
      <!-- [섹션] 정보  -->
      <div class="section" [id]="'section-info-' + product.id" *ngIf="product.isBusiness">
        <div class="section-title">정보</div>
        <!-- 숙소 -->
        <ng-container *ngIf="product.amenities.length > 0">
          <div class="info-box" style="margin-bottom: 24px">
            <div class="label">
              <div style="display: flex; gap: 8px; margin-bottom: 16px">
                <img src="/assets/new/house-siding.svg" />
                <div class="info-title">숙소</div>
              </div>
            </div>
            <div style="display: flex; justify-content: space-between; flex-wrap: wrap">
              <ul *ngFor="let amenity of product.amenities" style="width: 50%; margin: 7px 0px; padding-left: 22px">
                <li>{{ amenity.name }}</li>
              </ul>
            </div>
          </div>
        </ng-container>
        <!-- 준비물 -->
        <ng-container *ngIf="product.checkList">
          <div class="info-box" style="margin-bottom: 24px">
            <div class="label">
              <div style="display: flex; gap: 8px; margin-bottom: 16px">
                <img src="/assets/new/shopping-bag.svg" />
                <div class="info-title">준비물</div>
              </div>
            </div>
            <div class="pre-wrap" style="padding: 10px 10px 0px 3px">{{ product.checkList }}</div>
          </div>
        </ng-container>
        <!-- 포함 사항 -->
        <ng-container *ngIf="product.includeList">
          <div class="info-box" style="margin-bottom: 24px">
            <div class="label">
              <div style="display: flex; gap: 8px; margin-bottom: 16px">
                <img src="/assets/new/type99.svg" />
                <div class="info-title">포함 사항</div>
              </div>
            </div>
            <div class="pre-wrap" style="padding: 10px 10px 0px 3px">{{ product.includeList }}</div>
          </div>
        </ng-container>
        <!-- 불포함 사항 -->
        <ng-container *ngIf="product.excludeList">
          <div class="info-box" style="margin-bottom: 24px">
            <div class="label">
              <div style="display: flex; gap: 8px; margin-bottom: 16px">
                <img src="/assets/new/tabler_box.svg" />
                <div class="info-title">불포함 사항</div>
              </div>
            </div>
            <div class="pre-wrap" style="padding: 10px 10px 0px 3px">{{ product.excludeList }}</div>
          </div>
        </ng-container>
        <!-- 유의사항 -->
        <ng-container *ngIf="product.notice">
          <div class="info-box" style="margin-bottom: 24px" (click)="openBm(noticeTpl)">
            <div style="display: flex; justify-content: space-between; align-items: center">
              <div class="label" style="margin-bottom: 0px">
                <div style="display: flex; gap: 8px">
                  <img src="/assets/new/tabler_alert-triangle.svg" />
                  <div class="info-title">유의 사항</div>
                </div>
              </div>
              <img src="/assets/new/chevron-right.svg" class="nnb-icon" />
            </div>
          </div>
        </ng-container>
        <!-- 환불정책 -->
        <ng-container *ngIf="product.price !== 0">
          <div class="info-box" style="margin-bottom: 24px">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px">
              <div class="label" style="margin-bottom: 0px">
                <div style="display: flex; gap: 8px">
                  <img src="/assets/new/cash-banknote.svg" />
                  <div class="info-title">환불 정책</div>
                </div>
              </div>
            </div>

            <!-- Refund policies directly displayed -->
            <div class="refund-policy-container">
              <ul class="refund-policy-list" style="padding-left: 20px; margin-top: 8px">
                <li style="margin-bottom: 8px">{{ product.refundPolicy }}</li>
                <li>환불시에는 정상가에서 위약금, 쿠폰 할인 금액, 포인트 차감액을 차감한 금액을 환불합니다.</li>
              </ul>
            </div>
          </div>
        </ng-container>
      </div>
      <!-- [섹션] 장소  -->
      <div class="section" [id]="'section-place-' + product.id">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px">
          <div class="section-title" style="margin: 0px">장소</div>
          <div *ngIf="product.isOffline">
            <button class="nnb-btn-secondary nnb-btn-md">주소 복사</button>
          </div>
        </div>
        <div
          [id]="'product-detail-map-' + product.id"
          style="height: 15.313rem; border: 1px solid #e2e2e2; border-radius: 4px"
        ></div>
        <ng-container *ngIf="product.isOffline">
          <div style="display: flex; gap: 8px; margin-top: 24px">
            <img [src]="'/assets/new/map-2.svg'" style="width: 20px; height: 20px; flex-shrink: 0" />
            <div>
              <div>{{ product.address }}</div>
              <div>{{ product.detailAddress }}</div>
            </div>
          </div>
          <button
            *ngIf="product.howToCome"
            class="nnb-btn-outline nnb-btn-lg nnb-btn-block"
            style="margin-top: 24px"
            (click)="openBm(howToGoTpl)"
          >
            대중교통 이용방법
          </button>
        </ng-container>
        <ng-container *ngIf="!product.isOffline">
          <div>온라인 모임입니다.</div>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="product.version === 2">
      <!-- 상품 메뉴 -->
      <div class="menu">
        <div
          class="top-menu"
          [ngClass]="'section-introduction-' + product.id"
          (click)="setPosition('introduction', product.id)"
        >
          상세
        </div>
        <div
          *ngIf="product.courses?.length > 0"
          class="top-menu"
          [ngClass]="'section-schedule-' + product.id"
          (click)="setPosition('schedule', product.id)"
        >
          일정
        </div>
        <div
          *ngIf="product.priceImage"
          class="top-menu"
          [ngClass]="'section-price-' + product.id"
          (click)="setPosition('price', product.id)"
        >
          가격
        </div>
        <div class="top-menu" [ngClass]="'section-place-' + product.id" (click)="setPosition('place', product.id)">
          장소
        </div>
        <div
          *ngIf="product.isBusiness"
          class="top-menu"
          [ngClass]="'section-info-' + product.id"
          (click)="setPosition('info', product.id)"
        >
          안내/정책
        </div>
        <div class="top-menu" [ngClass]="'section-feed-' + product.id" (click)="setPosition('feed', product.id)">
          후기
        </div>
      </div>
      <div class="section" style="padding: 32px 0px" [id]="'section-introduction-' + product.id">
        <!-- 추천 성향 -->
        <div *ngIf="product.recommend">
          <div style="padding: 16px 16px 40px 16px">
            <div style="font-size: 18px; font-weight: 500; margin-bottom: 4px">추천 성향</div>
            <div class="pre-wrap">{{ product.recommend }}</div>
          </div>
        </div>
        <!-- 기타 정보 -->
        <div style="padding: 0px 16px" *ngIf="product.isBusiness && product.description">
          <div class="ql-container ql-snow" [style]="quillStyle">
            <div class="ql-editor" [innerHTML]="product.description | safeHtml"></div>
          </div>
          <!-- description 이미지 편집 (admin only) -->
          <description-image-editor
            [descriptionHtml]="product.description"
            [isAdminPage]="isAdminPage"
            (descriptionUpdated)="onDescriptionImageUpdated($event)"
          >
          </description-image-editor>
        </div>
        <!-- 상세 요약 -->
        <div style="margin-bottom: 48px">
          <div style="font-size: 22px; font-weight: 600; padding: 16px; margin-bottom: 16px">상세요약</div>
          <div *ngFor="let summary of product.summaries; let index = index; trackBy: trackByIndex">
            <div style="padding: 24px 16px" [ngStyle]="{ background: index % 2 === 0 ? '#F7F7F8' : '' }">
              <div style="display: flex; gap: 8px; align-items: center; margin-bottom: 8px">
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: #340879;
                    color: white;
                    font-weight: 700;
                    border-radius: 4px;
                    width: 28px;
                    height: 28px;
                  "
                >
                  {{ index + 1 | number: '2.0' }}
                </div>
                <div style="font-size: 20px; font-weight: 500">{{ summary.title }}</div>
              </div>
              <div style="font-size: 18px; font-weight: 400; margin-bottom: 8px">{{ summary.description }}</div>
              <!-- photos는 URL 문자열 배열(ProductSummary.photos: string[])이다. `.photo`를 붙여 읽으면
                   항상 undefined라 src=""가 되고, 브라우저가 현재 페이지 URL을 이미지로 요청해 180px짜리
                   깨진 박스가 남는다. 사진이 없는 요약은 통째로 건너뛴다. -->
              <ai-image-edit-overlay
                *ngIf="summary.photos?.[0]"
                [imageUrl]="summary.photos[0]"
                [imageKey]="getSummaryKey(index)"
                [showEditButton]="isAdminPage"
                (imageUpdated)="onSummaryPhotoUpdated(index, $event)"
              >
                <img [src]="summary.photos[0]" style="width: 100%; height: 180px; object-fit: cover" />
              </ai-image-edit-overlay>
            </div>
          </div>
        </div>
        <!-- 상세 -->
        <div *ngIf="product.sections">
          <div *ngFor="let section of product.sections; let sectionIndex = index; trackBy: trackByIndex" style="margin-bottom: 32px">
            <div style="font-size: 22px; font-weight: 600; padding: 16px; margin-bottom: 16px; line-height: 100%">
              {{ section.title }}
            </div>
            <div *ngFor="let paragraph of section.paragraphs; let paragraphIndex = index; trackBy: trackByIndex" style="margin-bottom: 32px">
              <div style="padding: 8px 16px; margin-bottom: 16px">
                <div style="width: 40px; height: 6px; background: #d2d2de; margin-bottom: 8px"></div>
                <div style="font-size: 20px; font-weight: 600; line-height: 150%">
                  {{ paragraph.title }}
                </div>
                <div
                  *ngIf="paragraph.time"
                  style="
                    margin-top: 8px;
                    padding: 7px 10px;
                    border-radius: 60px;
                    border: 1px solid #d2d2de;
                    display: inline-flex;
                    gap: 4px;
                    align-items: center;
                  "
                >
                  <img src="/assets/new/clock.svg" style="width: 20px; height: 20px; flex-shrink: 0" />
                  <div>{{ paragraph.time }}</div>
                </div>
              </div>
              <!-- 빈 사진 자리는 폼 순번을 맞추려고 ''로 남아 있어, src에 넣으면 깨진 박스가 된다. -->
              <ng-container *ngIf="paragraph.photos.length > 1">
                <swiper
                  [navigation]="true"
                  [config]="{
                    pagination: {
                      type: 'bullets',
                      dynamicBullets: true,
                      dynamicMainBullets: 3,
                    },
                  }"
                >
                  <ng-template swiperSlide *ngFor="let photo of paragraph.photos; let photoIndex = index; trackBy: trackByIndex">
                    <ai-image-edit-overlay
                      *ngIf="photo"
                      [imageUrl]="photo"
                      [imageKey]="getSectionKey(sectionIndex, paragraphIndex, photoIndex)"
                      [showEditButton]="isAdminPage"
                      (imageUpdated)="onSectionPhotoUpdated(sectionIndex, paragraphIndex, photoIndex, $event)"
                    >
                      <img [src]="photo" class="photo" />
                    </ai-image-edit-overlay>
                    <div style="height: 24px"></div>
                  </ng-template>
                </swiper>
              </ng-container>
              <ng-container *ngIf="paragraph.photos.length === 1 && paragraph.photos[0]">
                <ai-image-edit-overlay
                  [imageUrl]="paragraph.photos[0]"
                  [imageKey]="getSectionKey(sectionIndex, paragraphIndex, 0)"
                  [showEditButton]="isAdminPage"
                  (imageUpdated)="onSectionPhotoUpdated(sectionIndex, paragraphIndex, 0, $event)"
                >
                  <img [src]="paragraph.photos[0]" class="photo" />
                </ai-image-edit-overlay>
              </ng-container>
              <div
                class="pre-wrap"
                style="
                  margin-top: 16px;
                  padding: 8px 16px;
                  margin-bottom: 16px;
                  font-size: 18px;
                  font-weight: 400;
                  line-height: 150%;
                "
              >
                {{ paragraph.description }}
              </div>
              <div *ngIf="paragraph.note" style="padding: 0px 16px 16px 16px">
                <div
                  class="pre-wrap"
                  style="
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 160%;
                    padding: 16px;
                    border-radius: 4px;
                    background: #f2f3f8;
                  "
                >
                  {{ paragraph.note }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- [섹션] 일정 -->
      <div class="section" [id]="'section-schedule-' + product.id" *ngIf="product.courses?.length > 0">
        <div style="font-size: 20px; font-weight: 500; margin-bottom: 16px">일정</div>
        <div class="course" *ngFor="let course of product.courses; let last = last">
          <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px">
            <img src="/assets/new/dot-badge.png" />
            <div style="font-size: 18px; font-weight: 500">{{ course.title }}</div>
          </div>
          <div style="border-left: 1.4px solid #e8e8ef; padding-left: 16px">
            <div
              *ngFor="let schedule of course.schedules"
              style="padding: 12px 0px; border-bottom: 1.4px solid #e8e8ef"
            >
              <div style="display: flex; align-items: center; gap: 4px; margin-bottom: 8px">
                <img src="/assets/new/clock.svg" style="width: 20px; height: 20px; flex-shrink: 0" />
                <div style="font-size: 16px; font-weight: 500">{{ schedule.subTitle }}</div>
              </div>
              <div style="font-size: 16px; font-weight: 500; padding-left: 20px">{{ schedule.content }}</div>
              <div
                *ngIf="schedule.note"
                class="pre-wrap"
                style="font-size: 15px; line-height: 140%; color: #5b6371; padding-left: 20px; margin-top: 4px"
              >
                <div>{{ schedule.note }}</div>
              </div>
            </div>
          </div>
          <div *ngIf="!last" style="height: 32px"></div>
        </div>
      </div>
      <!-- [섹션] 가격 -->
      <div class="section" [id]="'section-price-' + product.id" *ngIf="product.priceImage">
        <div style="font-size: 20px; font-weight: 500; margin-bottom: 16px">가격</div>
        <ai-image-edit-overlay
          [imageUrl]="product.priceImage"
          imageKey="price"
          [showEditButton]="isAdminPage"
          (imageUpdated)="onPriceImageUpdated($event)"
        >
          <img [src]="product.priceImage" style="width: 100%" />
        </ai-image-edit-overlay>
      </div>
      <!-- [섹션] 장소  -->
      <div class="section" [id]="'section-place-' + product.id">
        <div style="font-size: 20px; font-weight: 500; margin-bottom: 16px">장소</div>
        <ng-container *ngIf="product.isOffline">
          <div
            [id]="'product-detail-map-' + product.id"
            style="height: 15.313rem; border: 1px solid #e2e2e2; border-radius: 8px"
          ></div>
          <div style="display: flex; gap: 8px; align-items: center; margin-bottom: 4px; margin-top: 16px">
            <img [src]="'/assets/new/map-pin-off.svg'" />
            <div style="font-size: 18px; font-weight: 500">주소</div>
          </div>
          <ul style="margin-bottom: 8px; padding-left: 27px">
            <li>{{ product.address }}, {{ product.detailAddress }}</li>
          </ul>
          <button class="nnb-btn-secondary nnb-btn-md nnb-btn-block">주소 복사</button>
          <ng-container *ngIf="product.howToCome">
            <div style="display: flex; gap: 8px; align-items: center; margin-bottom: 8px; margin-top: 16px">
              <img [src]="'/assets/new/map-2.svg'" style="width: 20px; height: 20px; flex-shrink: 0" />
              <div style="font-size: 18px; font-weight: 500">오시는 방법</div>
            </div>
            <div class="pre-wrap" style="padding: 16px; border-radius: 4px; background: #f2f3f8">
              {{ product.howToCome }}
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="!product.isOffline">
          <div>온라인 모임입니다.</div>
        </ng-container>
      </div>
      <!-- [섹션] 안내/정책  -->
      <div class="section" [id]="'section-info-' + product.id">
        <div style="font-size: 20px; font-weight: 500; margin-bottom: 16px">안내/정책</div>
        <!-- 숙소 -->
        <ng-container *ngIf="product.amenities.length > 0">
          <div style="margin-bottom: 40px">
            <div class="label">
              <div style="display: flex; gap: 8px; margin-bottom: 4px">
                <img src="/assets/new/house-siding.svg" />
                <div style="font-size: 18px; font-weight: 500">숙소</div>
              </div>
            </div>
            <div style="display: flex; justify-content: space-between; flex-wrap: wrap">
              <ul *ngFor="let amenity of product.amenities" style="width: 50%; margin: 7px 0px; padding-left: 22px">
                <li>{{ amenity.name }}</li>
              </ul>
            </div>
          </div>
        </ng-container>
        <!-- 준비물 -->
        <ng-container *ngIf="product.checkList">
          <div style="margin-bottom: 40px">
            <div class="label">
              <div style="display: flex; gap: 8px; margin-bottom: 4px">
                <img src="/assets/new/brand-appgallery.svg" />
                <div style="font-size: 18px; font-weight: 500">준비물</div>
              </div>
            </div>
            <div class="pre-wrap" style="padding: 10px 10px 0px 3px">{{ product.checkList }}</div>
          </div>
        </ng-container>
        <!-- 포함 사항 -->
        <ng-container *ngIf="product.includeList">
          <div style="margin-bottom: 40px">
            <div class="label">
              <div style="display: flex; gap: 8px; margin-bottom: 16px">
                <img src="/assets/new/type99.svg" />
                <div style="font-size: 18px; font-weight: 500">포함사항</div>
              </div>
            </div>
            <div class="pre-wrap" style="padding: 10px 10px 0px 3px">{{ product.includeList }}</div>
          </div>
        </ng-container>
        <!-- 불포함 사항 -->
        <ng-container *ngIf="product.excludeList">
          <div style="margin-bottom: 40px">
            <div class="label">
              <div style="display: flex; gap: 8px; margin-bottom: 4px">
                <img src="/assets/new/tabler_box.svg" />
                <div style="font-size: 18px; font-weight: 500">불포함 사항</div>
              </div>
            </div>
            <div class="pre-wrap" style="padding: 10px 10px 0px 3px">{{ product.excludeList }}</div>
          </div>
        </ng-container>
        <!-- 유의사항 -->
        <ng-container *ngIf="product.notice">
          <div style="padding: 16px; border-radius: 4px; background: #f2f3f8">
            <div style="font-weight: 700; margin-bottom: 4px">유의사항</div>
            <div class="pre-wrap">{{ product.notice }}</div>
          </div>
        </ng-container>
        <!-- 환불정책 -->
        <ng-container *ngIf="product.price !== 0">
          <div style="margin-top: 16px; padding: 14px 16px; border-radius: 8px; border: 1px solid #e8e8ef">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px">
              <div style="font-weight: 700; margin-bottom: 4px">환불 정책</div>
            </div>

            <!-- Refund policies directly displayed -->
            <div class="refund-policy-container">
              <ul class="refund-policy-list" style="padding-left: 20px; margin-top: 8px">
                <li style="margin-bottom: 8px">{{ product.refundPolicy }}</li>
                <li>환불시에는 정상가에서 위약금, 쿠폰 할인 금액, 포인트 차감액을 차감한 금액을 환불합니다.</li>
              </ul>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </main>
</div>

<ng-template #howToGoTpl>
  <div class="section-title">오시는 방법</div>
  <div class="pre-wrap" style="margin-bottom: 24px">{{ product.howToCome }}</div>
  <button class="nnb-btn-secondary nnb-btn-md nnb-btn-block" (click)="closeBm()">닫기</button>
</ng-template>

<ng-template #noticeTpl>
  <div class="section-title">유의 사항</div>
  <div class="pre-wrap" style="margin-bottom: 24px">{{ product.notice }}</div>
  <button class="nnb-btn-secondary nnb-btn-md nnb-btn-block" (click)="closeBm()">닫기</button>
</ng-template>
